type Option = {
  value: number;
  title: string;
};

type selectOptionsConfig = Record<string, Option[]>;

export const selectOptionsParams: selectOptionsConfig = {
  "1": [
    { value: 10, title: "Положительная" },
    { value: 0, title: "Отсутствует" },
    { value: -10, title: "Отрицательная" },
  ],
  "2": [
    { value: 5, title: "Свыше 3 лет" },
    { value: 3, title: "От 1 до 3 лет" },
    { value: 2, title: "От 6 до 12 месяцев" },
    { value: -5, title: "Менее 6 месяцев" },
  ],
  "3": [
    { value: 6, title: "Имеется" },
    { value: 0, title: "Не имеется / нет данных" },
  ],
  "4": [
    { value: 10, title: "Свыше 10 контрактов" },
    { value: 8, title: "От 3 до 10 контрактов" },
    { value: 4, title: "От 1 до 3 контрактов" },
    { value: 0, title: "Не имеется / нет данных" },
  ],
  "5": [
    {
      value: 5,
      title:
        "Изменений не было ИЛИ были по собственникам, совокупно владеющим менее 25% акций (долей)",
    },
    {
      value: 0,
      title:
        "Изменения были по собственникам, совокупно владеющим не менее 25% акций (долей), но не более 50%",
    },
    {
      value: -5,
      title:
        "Изменения были по собственникам, совокупно владеющим  более 50% акций (долей)",
    },
  ],
  "6": [
    { value: 5, title: "Не имеются " },
    { value: -5, title: "Имеются " },
  ],
  "7": [
    { value: 5, title: "Не имеются " },
    { value: -5, title: "Имеются " },
  ],
  "8": [
    { value: 4, title: "Расхождения отсутствуют " },
    {
      value: 0,
      title:
        "Расхождения имеются, но незначительные (менее, чем на 10%) ИЛИ в источниках нет данных отчетности Клиента",
    },
    { value: -4, title: "Расхождения имеются (более, чем на 10%)" },
  ],
};
